import {Component, OnDestroy, OnInit} from '@angular/core';
import {ResponsesService} from '../../../common/services/responses/responses.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SubSink} from '@Common/core/utils/subsink';
import {FormModel} from '../../../common/components/form/models';
import {ResponseForm} from '../../../common/components/form/models/responsedemat.model';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-container-response',
  templateUrl: './container-response.component.html',
  styleUrls: ['./container-response.component.scss']
})
export class ContainerResponseComponent implements OnInit, OnDestroy {
  response: ResponseForm;
  form: FormModel;
  loadingResponse = false;
  subSink = new SubSink();
  constructor(private route: ActivatedRoute,
              private router: Router,
              private responsesSvc: ResponsesService) { }

  ngOnInit(): void {
    this._loadResponse();
  }
  listResponses() {
    this.router.navigate(['responses', this.form.uuid], {relativeTo: this.route.parent});
  }
  private _loadResponse() {
    this.loadingResponse = true;
    const uuid = this.route.snapshot.paramMap.get('uuid');
    this.subSink.sink = this.responsesSvc.get(uuid)
      .pipe(finalize(() => this.loadingResponse = false))
      .subscribe((_response: ResponseForm) => {
        this.response = _response;
        this.form = _response.form_obj;
      });
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
